import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import styled from 'styled-components';
import { REPORT_MODAL } from '../../containers/modal/modal-types';

import { useWindowSize } from '../../lib/hooks';
import { Show } from '../show';
import ReportPopover from './components/popover';
import { showModal, hideModal, hideReport } from '../../actions/modal';
import { clearForm } from '../../actions/report';

export const ReportWrapper = styled.div`
    position: absolute;
    bottom: 56px;
    left: ${(props) => (props.isCorrectionPage ? '150px' : '80%')};
    top: ${(props) => props.isCorrectionPage && '-50px'};
    z-index: 3;
`;

const Report = ({ snackbarStatus, showReport, hideModal, showModal, hideReport, clearForm, httpStatus, isCorrectionPage = false }) => {
    const { innerWidth } = useWindowSize();
    const isMobile = innerWidth < 1152;

    useEffect(() => {
        if (showReport && isMobile) {
            showModal(REPORT_MODAL);
        } else if (showReport && !isMobile) {
            hideModal();
        }
    }, [showReport, isMobile, showModal, hideModal]);

    return (
        <Show when={showReport}>
            {!isMobile && (
                <ReportWrapper isCorrectionPage={isCorrectionPage}>
                    <ReportPopover
                        snackbarStatus={snackbarStatus}
                        hideReport={hideReport}
                        clearForm={clearForm}
                        httpStatus={httpStatus}
                        isCorrectionPage={isCorrectionPage}
                    />
                </ReportWrapper>
            )}
        </Show>
    );
};

Report.propTypes = {
    showReport: PropTypes.bool,
    snackbarStatus: PropTypes.string,
    showModal: PropTypes.func,
    hideModal: PropTypes.func,
    hideReport: PropTypes.func,
    clearForm: PropTypes.func,
    httpStatus: PropTypes.object,
    isCorrectionPage: PropTypes.bool,
};

const actionCreators = {
    showModal,
    hideModal,
    hideReport,
    clearForm,
};

const mapStateToProps = (state) => {
    return {
        httpStatus: state.report.status,
    };
};

export default connect(mapStateToProps, actionCreators)(Report);
